import { Flex, Image, Text } from '@chakra-ui/react'
import React from 'react'
import arqgenLogo from '../../assets/ag-logo-with-name.png'
import gerdauLogo from '../../assets/new-logoGerdau.png'

export function Logo(){
  return (
    <Flex flexDirection="column" gap='20px'>
      <Image h='fit-content' w='fit-content' src={gerdauLogo} alt='Logo Gerdau com nome'/>
      <Flex gap='8px'>
        <Text fontSize="16px" color='#344054'>criado por</Text>
        <Image w='fit-content' h='fit-content' objectFit="cover" src={arqgenLogo} alt='Logo Arqgen com nome' />
      </Flex>
    </Flex>
  )
}